import {dsDtos} from '@vectronic/openApi-customer'
import {Buffer} from 'buffer'
import {Parse} from './parse'

export class ParseRange {
  static do(dto: dsDtos.Parameter, validValueRange?: dsDtos.ValidValueRange) {
    let min: string | undefined = undefined
    let max: string | undefined = undefined
    let list: (string | undefined)[] | undefined = undefined
    if (validValueRange?.list) {
      list = validValueRange.list.map((value) => {
        const buffer = Buffer.alloc(dto.length!)
        buffer.writeUintLE(value, 0, dto.length!)
        return Parse.do(dto, buffer)?.toString()
      })
    } else {
      const maxBuffer = Buffer.alloc(dto.length!, 255)
      maxBuffer.writeUIntLE(254, 0, 1)
      if (validValueRange?.max !== undefined) maxBuffer.writeUintLE(validValueRange.max!, 0, dto.length!)
      max = Parse.do(dto, maxBuffer)?.toString()
      const minBuffer = Buffer.alloc(dto.length!, 0)
      if (validValueRange?.min !== undefined) minBuffer.writeUintLE(validValueRange.min!, 0, dto.length!)
      min = Parse.do(dto, minBuffer)?.toString()
    }
    return {max, min, list}
  }
}
